import React, {ChangeEvent} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {SurveyScope} from 'client/common/types';
import {SurveyPreset} from 'client/common/types/survey';

import {useSurveySlug} from 'client/common/contexts/slug';
import {useSurveyPreset} from 'client/common/hooks/box';
import {useIsYandexPublisher} from 'client/common/hooks/user';
import {useCanEditSurveySettings} from 'client/common/hooks/edit-mode';
import {isYandexTeamDomain, YandexTeamSurveyScopes} from 'client/common/utils/yandex-team';

import BlockInput from 'client/common/components/block-input';
import {SelectWithForwardView as Select} from 'client/common/components/lego';

import './edit-settings.css';

const i18n = I18N.common.surveySettings.editSettingsModal;

const b = b_.with('edit-settings-modal');

const SCOPE_OPTIONS = Object.values(SurveyScope).map(value => ({
    value,
    content: i18n.scope[value]
}));

interface ScopeSelectorProps {
    scope?: SurveyScope;
    handleScopeChange: (event: ChangeEvent<HTMLSelectElement>) => Promise<void>;
}

const HelpPopupContent = () => {
    return (
        <div
            className={b('help-description')}
            dangerouslySetInnerHTML={{__html: i18n.scopeHelpDescription}}
        />
    );
};

export default function ScopeSelect(props: ScopeSelectorProps) {
    const {handleScopeChange, scope} = props;

    const canEdit = useCanEditSurveySettings();
    const isYandexPublisher = useIsYandexPublisher();
    const slug = useSurveySlug();
    const surveyPreset = useSurveyPreset(slug);

    let scopeOptions = SCOPE_OPTIONS.filter(({value}) => {
        // показываем выбранное размещение
        if (scope === value) {
            return true;
        }

        // на ятим не фильтруем, показываем все варианты
        if (isYandexTeamDomain) {
            return true;
        }

        // на внешнем скрываем ятим варианты
        return !YandexTeamSurveyScopes.has(value);
    });

    if (
        surveyPreset === SurveyPreset.YandexActiveFeedback ||
        surveyPreset === SurveyPreset.YandexPassiveFeedback ||
        surveyPreset === SurveyPreset.YandexMorda
    ) {
        scopeOptions = scopeOptions.filter(({value}) => value !== 'external');
    }

    if (!isYandexPublisher) {
        return null;
    }

    return (
        <BlockInput
            popupContent={<HelpPopupContent />}
            title={i18n.scope.label}
            description={isYandexTeamDomain ? null : i18n.yaTeamDisclaimer}
        >
            <Select
                className={b('select-control')}
                disabled={!canEdit}
                onChange={handleScopeChange}
                options={scopeOptions}
                size='m'
                value={scope ?? SurveyScope.Yandex}
                view='dl-clear'
            />
        </BlockInput>
    );
}
